/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Select, Cascader, Checkbox, DatePicker, Input } from 'antd'
import classNames from 'classnames'
import { isArray } from '../../utils/type'
import Icon from '../icon'
import './styleSelect.less'
import isIPad from '../../common/isIPad'

const { Option } = Select
const { MonthPicker } = DatePicker

export const StyleSelect = (props) => {
  const { value, options, onChange, placeholder, showSearch, style, onFocus, className } = props
  const [filterValue, setFilterValue] = useState()
  useEffect(() => {
    if (value instanceof Array) {
      if (value[0] != '' && value[0] != undefined && value[0] != 'null') {
        setFilterValue(value[0])
      } else {
        setFilterValue(undefined)
      }
    } else {
      setFilterValue(value != '' ? value : undefined)
    }
  }, [value, options])

  return (
    <div className="mn-style-select" style={style}>
      <Select
        className={className}
        showSearch={showSearch}
        onFocus={onFocus}
        filterOption={(input, option) => option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        allowClear
        value={filterValue}
        placeholder={placeholder}
        defaultActiveFirstOption={false}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        onChange={(value) => onChange(value)}
        dropdownClassName="mn-style-select-dropdown"
        optionLabelProp="label"
        options={options}
      >
        {options?.length > 0
          ? options.map((m) => {
            return (
              <Option value={m.value} label={m.label} className="select-option">
                {filterValue == m.value ? <Icon type="m-xiaoyan" /> : <span className="icon-perch" />}
                <span className="select-label">{m.label}</span>
              </Option>
            )
          })
          : null}
      </Select>
      {/* <Select
        className={className}
        showSearch={showSearch}
        onFocus={onFocus}
        filterOption={(input, option) => option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        clearText={false}
        value={filterValue}
        placeholder={placeholder}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        onChange={(e) => onChange(e.value)}
        popupClassName="mn-style-select-dropdown"
        optionLabelProp="label"
        data={options}
        trigger="click"
      /> */}
    </div>
  )
}

export const StyleCascader = (props) => {
  const { value, options, onChange, placeholder } = props
  const [filterValue, setFilterValue] = useState([])
  useEffect(() => {
    if (value?.[0] == '') {
      setFilterValue([])
    } else {
      setFilterValue(value)
    }
  }, [value])
  return (
    <div className="mn-cascader-container">
      <Cascader
        expandTrigger="hover"
        value={filterValue}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      />
    </div>
  )
}

export const SelectDay = (props) => {
  const { value, onChange } = props
  const [time, setTime] = useState(null)
  useEffect(() => {
    if (value == undefined || !value || value?.[0] == 'null' || !value?.[0]) {
      setTime(null)
    } else {
      setTime(moment(value?.[0]))
    }
  }, [value])
  const onDayChange = (value) => {
    if (value == null) {
      onChange && onChange('null')
    } else {
      onChange && onChange(moment(value).format('YYYY-MM-DD'))
    }
  }
  return (
    <div className="mn-selectday-container">
      <DatePicker
        inputReadOnly={isIPad}
        value={time}
        onChange={onDayChange}
        showToday={false}
        placeholder="选择时间"
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      />
    </div>
  )
}

export const SelectMonth = (props) => {
  const { value, onChange } = props
  const [time, setTime] = useState(null)
  useEffect(() => {
    if (value == undefined || !value || value?.[0] == 'null' || !value?.[0]) {
      setTime(null)
    } else {
      setTime(moment(value?.[0]))
    }
  }, [value])
  const onMonthChange = (value) => {
    if (value == null) {
      onChange && onChange('null')
    } else {
      onChange && onChange(moment(value).format('YYYY-MM'))
    }
  }
  return (
    <div className="mn-selectmonth-container">
      <MonthPicker
        inputReadOnly={isIPad}
        value={time}
        onChange={onMonthChange}
        placeholder="选择时间"
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      />
    </div>
  )
}

export const SelectYear = (props) => {
  const { value, onChange } = props
  const [isopen, setIsopen] = useState(false)
  const [time, setTime] = useState(null)
  useEffect(() => {
    if (value == undefined || !value || value?.[0] == 'null' || !value?.[0]) {
      setTime(null)
    } else {
      setTime(moment(value?.[0]))
    }
  }, [value])
  const handleOpenChange = (status) => {
    if (status) {
      setIsopen(true)
    } else {
      setIsopen(false)
    }
  }
  const handlePanelChange = (value) => {
    setIsopen(false)
    setTime(value)
    onChange && onChange(moment(value).format('YYYY'))
  }
  const onClear = () => {
    setTime(null)
    onChange && onChange('null')
  }
  return (
    <div className="mn-selectyear-container">
      <DatePicker
        inputReadOnly={isIPad}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        value={time}
        open={isopen}
        mode="year"
        format="YYYY"
        onOpenChange={handleOpenChange}
        onPanelChange={handlePanelChange}
        onChange={onClear}
        placeholder="选择时间"
      />
    </div>
  )
}

export const MnInputNum = (props) => {
  const { value, onChange, suffix, className, style, placeholder = '0', decimalPlaces } = props
  const onInputChange = (e) => {
    const inputValue = e.target.value
    // 只允许输入数字和小数点
    const formattedValue = inputValue
      .replace(/[^\d.]+/g, '') // 只保留数字和小数点
      .replace(/(\..*?)\..*/g, '$1') // 只允许一个小数点

    // 如果 decimalPlaces 存在，则限制小数位数
    const finalValue = decimalPlaces
      ? formattedValue.replace(new RegExp(`(\\.\\d{${decimalPlaces}})\\d+`, 'g'), '$1')
      : formattedValue

    onChange && onChange(finalValue)
  }
  // eslint-disable-next-line no-nested-ternary
  const defaultValue = value instanceof Array ? (value[0] === 'null' ? 0 : value[0]) : value
  return (
    <div className={classNames('mn-style-input-number', className)} style={style}>
      <Input value={defaultValue === 0 ? '' : defaultValue} placeholder={placeholder} onChange={onInputChange} />
      <div className="suffix">{suffix}</div>
    </div>
  )
}

export const MnTextInput = (props) => {
  const { value, onChange, localKey, localType } = props
  const [historyList, setHistoryList] = useState([])
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    // 根据id获取本地存储的数据
    if (localType == 'sample') {
      const result = window.localStorage.getItem('mnEditSampleParams')
      if (result) {
        const convertResult = JSON.parse(result).find((m) => m.propertyId === localKey)
        setHistoryList(convertResult?.values)
      }
      return
    }
    const result = window.localStorage.getItem('mnEditImageParams')
    if (result) {
      const convertResult = JSON.parse(result).find((m) => m.propertyId === localKey)
      setHistoryList(convertResult?.values)
    }
    // 获取到一个数组，根据id查询数组找到对应的历史
  }, [localKey, localType])
  useEffect(() => {
    window.addEventListener('mousedown', click)
    return () => window.removeEventListener('mousedown', click)
  }, [])
  const click = () => {
    setVisible(false)
  }
  const onTextChange = (e) => {
    onChange && onChange(e.target.value)
  }
  const onTextMouseDown = (e) => {
    e.nativeEvent.stopPropagation()
    if (historyList?.length > 0) {
      setVisible(true)
    }
  }
  const onClickItem = (m) => {
    onChange && onChange(m)
  }
  const clearHistoryData = () => {
    if (localType == 'sample') {
      const result = window.localStorage.getItem('mnEditSampleParams')
      if (result) {
        const convertResult = JSON.parse(result).filter((m) => m.propertyId != localKey)
        window.localStorage.setItem('mnEditSampleParams', convertResult)
        setHistoryList([])
      }
      return
    }
    const result = window.localStorage.getItem('mnEditImageParams')
    if (result) {
      const convertResult = JSON.parse(result).filter((m) => m.propertyId != localKey)
      window.localStorage.setItem('mnEditImageParams', convertResult)
      setHistoryList([])
    }
  }
  return (
    <div className="mn-style-input-text">
      <Input maxLength={20} placeholder="请输入纯文本" value={value} onChange={onTextChange} onMouseDown={onTextMouseDown} />
      <div className="suffix">{`${value?.length} / 20`}</div>
      {historyList?.length > 0 && visible ? (
        <div className="history-container">
          <div className="histtory-header">
            <span>最近使用</span>
            <span onClick={clearHistoryData}>清除记录</span>
          </div>
          <div className="history-item-content">
            {historyList?.map((m) => {
              if (m != '') {
                return (
                  <div className="history-item" onMouseDown={() => onClickItem(m)}>
                    {m}
                  </div>
                )
              }
            })}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export const MultipleSelect = (props) => {
  const { value, onChange, asyncoptions } = props
  const [checkVal, setCheckVal] = useState(new Set())
  const [selectVal, setSelectVal] = useState([])
  const [tagsVal, setTagsVal] = useState([])
  const [options, setOptions] = useState(asyncoptions)

  useEffect(() => {
    console.log('value', value)
    if (isArray(value)) {
      setCheckVal(new Set(value))
    }
    if (asyncoptions?.length > 0) {
      setOptions(asyncoptions)
    }
  }, [value, asyncoptions])

  useEffect(() => {
    setSelectVal(Array.from(checkVal))
  }, [checkVal])
  useEffect(() => {
    if (options?.length > 0) {
      setTagsVal(selectVal.map((item) => options?.find((i) => i.value == item))?.map((j) => j?.label))
    }
  }, [selectVal])
  const onGroupChange = (value) => {
    onChange && onChange(value)
  }
  const onChangeCheck = (item, e) => {
    e.preventDefault()
    if (checkVal.has(item.value)) {
      checkVal.delete(item.value)
      setCheckVal(new Set(checkVal))
    } else {
      checkVal.add(item.value)
      setCheckVal(new Set(checkVal))
    }
    onChange && onChange(Array.from(checkVal))
  }
  const removeTag = (m) => {
    checkVal.delete(options?.find((item) => item.label == m)?.value)
    setCheckVal(new Set(checkVal))
    onChange && onChange(Array.from(checkVal))
  }

  const menu = () => {
    return (
      <div className="select-option-container">
        <Checkbox.Group value={selectVal} onChange={onGroupChange}>
          {options?.length > 0
            ? options.map((m) => {
              return (
                <div
                  className="select-option-item"
                  onClick={(e) => onChangeCheck(m, e)}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <Checkbox onClick={(e) => e.stopPropagation()} value={m.value}>
                    <span className="option-label">{m.label}</span>
                  </Checkbox>
                </div>
              )
            })
            : null}
        </Checkbox.Group>
      </div>
    )
  }
  return (
    <Select
      maxTagCount="responsive"
      showArrow
      getPopupContainer={(triggerNode) => triggerNode}
      dropdownMatchSelectWidth={false}
      mode="multiple"
      dropdownRender={menu}
      value={tagsVal}
      onDeselect={removeTag}
      className="mn-style-multiple-select-container"
      placeholder="点击选择"
      showSearch={false}
    />
  )
}

export const MultipleCascader = (props) => {
  const { options, value, onChange, placeholder } = props
  const childrenKey = 'children'
  const selectChildren = true
  const [caseTree, setCaseTree] = useState([])
  const [selectedValues, setSelectedValues] = useState([])
  const [clonedOpts, setClonedOpts] = useState([])
  useEffect(() => {
    initOptions()
  }, [options])

  useEffect(() => {
    if (value?.length > 0) {
      const newValue = value.filter((m) => m && m.trim())
      setSelectedValues([...newValue])
    }
  }, [value])

  /* useEffect(() => {
    console.log('数据改造caseTree', caseTree)
  }, [caseTree])  */

  useEffect(() => {
    recursiveOpt(clonedOpts, null)
    setCaseTree([clonedOpts])
  }, [clonedOpts])

  const initOptions = () => {
    setClonedOpts(deepClone(options))
  }

  const deepClone = (source) => {
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'shallowClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach((keys) => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  }

  const hasArrayChild = (obj, childrenKey) => {
    return obj[childrenKey] && Array.isArray(obj[childrenKey])
  }

  // 展示标签所有层级
  const getLevel = (node, key) => {
    const levels = []
    function loop(data) {
      levels.push(data[key])
      if (data.parent) {
        loop(data.parent)
      }
    }
    loop(node)
    return levels.reverse().join('^')
  }

  /**
   * 根据当前节点 checked
   * 更改所有子孙节点 checked
   */
  const markChildrenChecked = (node) => {
    function loop(children, status) {
      if (children) {
        children.map((child) => {
          if (!child.disabled) {
            child.checked = status
            if (child.checked) {
              child.indeterminate = false
            }
          }
          if (hasArrayChild(child, childrenKey)) {
            loop(child[childrenKey], status)
          }
        })
      }
    }
    if (node && hasArrayChild(node, childrenKey) && selectChildren) {
      loop(node[childrenKey], node.checked)
    }
  }
  /**
   * 根据当前节点的 checked
   * 标记父节点 checked、indeterminate 状态
   */
  const markParentChecked = (node) => {
    node.indeterminate = false
    function loop(node) {
      let checkCount = 0
      if (hasArrayChild(node, childrenKey)) {
        const childIndeterminate = node[childrenKey].some((child) => child.indeterminate)
        node[childrenKey].map((child) => {
          if (child.checked) {
            checkCount++
          }
        })
        // 子节点全部被选中
        if (checkCount === node[childrenKey].length) {
          node.checked = true
          node.indeterminate = false
        } else {
          node.checked = false
          if (checkCount > 0 || childIndeterminate) {
            node.indeterminate = true
          } else {
            node.indeterminate = false
          }
        }
      }
      if (node.parent) {
        loop(node.parent)
      }
    }
    if (node && node.parent && selectChildren) {
      loop(node.parent)
    }
  }

  // 展开下一级
  const spreadNext = (children, index) => {
    if (index || index === 0) {
      if (caseTree.indexOf(children) === -1) {
        if (children && children.length > 0) {
          caseTree.splice(index + 1, caseTree.length - 1, children)
          setCaseTree([...caseTree])
        } else {
          caseTree.splice(index + 1, caseTree.length - 1)
          setCaseTree([...caseTree])
        }
      }
    }
  }

  /**
   * 递归option数据
   * 标记数据树形层级 parent
   * 打上初始状态 checked indeterminate
   */
  const recursiveOpt = (nodeArr, parent) => {
    nodeArr.forEach((node) => {
      if (parent) {
        node.parent = parent
      }
      node.indeterminate = false
      node.checked = false
      if (selectedValues?.some((val) => val == getLevel(node, 'value'))) {
        node.checked = true
      }
      markChildrenChecked(node)
      markParentChecked(node)
      if (hasArrayChild(node, childrenKey)) {
        recursiveOpt(node[childrenKey], node)
      }
    })
  }

  /**
   * 处理已选中
   * 重新遍历tree，pick除已选中项目
   */
  const pickCheckedItem = (tree) => {
    const newSelectedValues = []
    setSelectedValues([])
    onChange && onChange([])
    function loop(data) {
      if (Array.isArray(data)) {
        data.map((item) => {
          let checkCount = 0
          if (hasArrayChild(item, childrenKey)) {
            item[childrenKey].map((child) => {
              if (child.checked) {
                checkCount++
              }
            })
          }
          if (item.checked) {
            if (checkCount === item[childrenKey]?.length) {
              onChange && onChange([...newSelectedValues])
              setSelectedValues([...newSelectedValues])
            } else {
              newSelectedValues.push(getLevel(item, 'value'))
              onChange && onChange([...newSelectedValues])
              setSelectedValues([...newSelectedValues])
            }
          }
          if (hasArrayChild(item, childrenKey)) {
            loop(item[childrenKey])
          }
        })
      }
    }
    loop(tree)
  }

  // 点击选择框
  const onCheckChange = (item, checked) => {
    item.checked = checked
    markChildrenChecked(item)
    markParentChecked(item)
    pickCheckedItem(clonedOpts)
  }

  // 点击删除标签
  const removeTag = (m) => {
    /**
     * 遍历 tree
     * 根据传入label 寻找 item
     */
    function findNodeByValue(value) {
      let result = null
      function loop(tree) {
        if (tree) {
          tree.find((node) => {
            if (getLevel(node, 'value') == value) {
              result = node
              return true
            }
            if (hasArrayChild(node, childrenKey)) {
              loop(node[childrenKey])
            }
          })
        }
      }
      if (value) {
        loop(clonedOpts)
        return result
      }
    }
    const deletedItem = findNodeByValue(m.replaceAll('/', '^'))
    if (deletedItem) {
      onCheckChange(deletedItem, false)
    }
  }

  const menu = () => {
    return (
      <div className="mn-style-multiple-cascader-level">
        {caseTree?.length > 0
          && caseTree.map((caseItem, index) => {
            return (
              <div className="cascader-container-levelone" key={caseItem.value}>
                {caseItem.map((item) => {
                  return (
                    <div
                      className="check-item"
                      onClick={(e) => e.preventDefault()}
                      onMouseDown={(e) => e.preventDefault()}
                      onMouseEnter={() => spreadNext(item[childrenKey], index)}
                      title={item.value}
                    >
                      <Checkbox
                        onClick={(e) => e.stopPropagation()}
                        checked={item.checked}
                        indeterminate={item.indeterminate}
                        onChange={(e) => onCheckChange(item, e.target.checked)}
                      >
                        {item.value}
                      </Checkbox>
                      {item.children?.length > 0 && <Icon type="m-Vxing_you" />}
                    </div>
                  )
                })}
              </div>
            )
          })}
      </div>
    )
  }
  return (
    <Select
      maxTagCount="responsive"
      showArrow
      getPopupContainer={(triggerNode) => triggerNode}
      dropdownMatchSelectWidth={false}
      mode="multiple"
      value={selectedValues?.map((item) => item.replaceAll('^', '/'))}
      onDeselect={removeTag}
      dropdownRender={menu}
      className="mn-style-multiple-cascader-container"
      placeholder={placeholder}
      showSearch={false}
    />
  )
}
